import React from "react";
import { observer } from "mobx-react";

import WindowPopup from "./WindowPopup";
import { useIntl } from "react-intl";
import useStores from "../../hooks/useStores";

let YoutubeVideoPopupWithState = () => {
  const { uiState } = useStores();
  const { formatMessage } = useIntl();

  const { plan, youtubeVideoLink, setYoutubeVideoLink } = uiState;
  if (plan == null || youtubeVideoLink == null) return null;

  const videoUrl = formatMessage({ id: youtubeVideoLink });
  if (videoUrl == null) return null;

  return (
    <WindowPopup
      close={() => setYoutubeVideoLink()}
      className="youtube-video-popup"
    >
      <div>
        <div className="youtube-video-popup">
          <iframe
            title="water-supply-video"
            width="772"
            height="433"
            src={videoUrl}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </WindowPopup>
  );
};

YoutubeVideoPopupWithState = observer(YoutubeVideoPopupWithState);
export default YoutubeVideoPopupWithState;
